module.exports = __webpack_public_path__ + "static/img/copytestbtn.b68f196e.svg";